import { DeviceOperationalState } from '@/__generated__/graphql';

export const ALLOWED_OPERATIONAL_STATES = [
  DeviceOperationalState.Development,
  DeviceOperationalState.Initialization,
  DeviceOperationalState.Active,
  DeviceOperationalState.Maintenance,
  DeviceOperationalState.OutOfService,
];
